import { Disclosure } from "@headlessui/react";
import { AuthDropdown } from "@/components/AuthDropdown";

/**
 * Application header with logo and user menu.
 * Full-width styling for the AI Playground landing page.
 */
const Header = () => {
  return (
    <Disclosure as="nav" className="bg-[#0072ce]">
      {() => (
        <div className="mx-auto w-full px-4 sm:px-6 lg:px-8">
          <div className="relative flex h-16 items-center justify-between">
            <div className="flex flex-1 items-center justify-start">
              <div className="flex shrink-0 items-center">
                <img
                  src="/elanco-logo.png"
                  alt="Elanco"
                  className="block"
                  height={40}
                  width={81}
                />
              </div>
            </div>
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
              <AuthDropdown />
            </div>
          </div>
        </div>
      )}
    </Disclosure>
  );
};

export default Header;
